var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-contain"},[_c('div',{staticClass:"header-block"}),_c('div',{staticClass:"home-page"},[_c('div',{staticClass:"header"},[_c('img',{staticStyle:{"height":"40px"},attrs:{"src":require("@/assets/apexis-logo.svg"),"alt":"Apexis Logo"}}),_c('div',{staticClass:"header-btn-contain"})])])])
}]

export { render, staticRenderFns }